import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { Company } from '@classes/company';
import { CompanyService } from 'app/core/services/company.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss']
})
export class CompanyListComponent implements OnInit {

  @Input() set control(ctr: FormControl | null) {
    if (ctr) {
      this.myControl = ctr;
      this._initFilteredCompanies();
    }
  }
  @Input() placeHolder: string;

  myControl!: FormControl;

  companies: Company[] = [];
  filteredCompanies: Observable<Company[]> | undefined;

  constructor(
    public companyService: CompanyService
  ) {
    this._initList();
  }

  ngOnInit() {
  }

  private _initList() {
    this.companyService.getCompanies().subscribe(companies => {
      this.companies = companies
        .sort((a, b) => ((a.name || "").toLowerCase() > (b.name || "").toLowerCase()) ? 1 : (((b.name || "").toLowerCase() > (a.name || "").toLowerCase()) ? -1 : 0));;
      this._initFilteredCompanies();
    }, error => {
      console.error(error);
    })
  }

  private _initFilteredCompanies(): void {
    if (this.myControl) {
      this.filteredCompanies = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            if (typeof value === 'string') {
              return this._filter(value);
            }
            return [];
          })
        );
    }
  }

  private _filter(value: string): Company[] {
    const filterValue = value.toLowerCase();
    return this.companies.filter(option => (option.name || '').toLowerCase().includes(filterValue));
  }

  displayFn(company?: Company): string {
    return company ? (company.name || '') : '';
  }
}
